import { Component, Input } from '@angular/core';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { FilterService, BaseFilterCellComponent } from '@progress/kendo-angular-grid';
import { union } from 'lodash';

@Component({
  standalone: false,
  selector: 'app-dropdown-filter',
  templateUrl: './dropdownlist.component.html',
  styleUrls: ['./dropdownlist.component.scss']
})
export class DropDownListFilterComponent extends BaseFilterCellComponent
{
  /** Matches global .k-list-item min-height (32px) plus padding; capped for long filter lists. */
  private static readonly LIST_ITEM_PX = 34;
  private static readonly LIST_MAX_PX = 400;

  @Input() public selectDefaultText: string;
  @Input() public filter: CompositeFilterDescriptor;
  @Input() public textField: string;
  @Input() public valueField: string;
  @Input() public filterField: string;
  @Input() public ariaLabel: string;

  public internalData: any = [];

  constructor(filterService: FilterService)
  {
    super(filterService);
  }

  public get dropdownListHeight(): number
  {
    const itemCount = this.internalData?.length ?? 1;
    return Math.min(
      DropDownListFilterComponent.LIST_MAX_PX,
      itemCount * DropDownListFilterComponent.LIST_ITEM_PX + 8);
  }

  public get selectedValue(): any
  {
    let filter = this.filterByField(this.valueField);
    // If value field used us displayName, check with the filterField
    if (filter === undefined)
    {
      filter = this.filterByField(this.filterField);
    }
    return filter ? filter.value : null;
  }

  @Input() public set data(data: any)
  {
    this.internalData = union([{
      [this.textField]: this.selectDefaultText, [this.valueField]: null
    }], data);
  }

  public onChange(value: any): void
  {
    const filter: any = {};
    filter.field = this.filterField;
    filter.operator = 'eq';
    filter.value = value;

    this.applyFilter(value === null ? // value of the default item
      // remove the filter
      this.removeFilter(this.filterField) :
      // add a filter for the field with the value
      this.updateFilter(filter)
    ); // update the root filter
  }
}
